<template>
    <section class="page-section" v-loading="pageLoading">
                
                <el-form size="small" :model="form" :rules="rules" label-width="90px" class="content-form no-padding-bottom pt20" ref="form">
                    <el-form-item label="门店" prop="name">
                        <el-input class="w300" v-model="form.name" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="电话" prop="tel">
                        <el-input class="w300" v-model="form.tel" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="address">
                      <el-input type="textarea" :rows="4" placeholder="请输入" v-model="form.address" class="w300" resize="none"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button size="small" type="primary" @click="handleCommit('form')" :loading="btnLoading">确定</el-button>
                        <el-button size="small" type="default" plain @click="handleback">取消</el-button>
                    </el-form-item>
                </el-form>
            </section>
</template>

<script>
import { serviceShopSaveOrUpdate } from '../../../common/api';

export default {
    data() {
        return {
            id: this.$route.query.id,
            form: {
                name: '', // 姓名
                tel: '', // 手机号
                address: ''
            },

            pageLoading: false,
            btnLoading: false,

            rules: {
                name: [
                    { required: true, message: '请输入门店', trigger: 'blur' }
                ],
                tel: [
                    { required: true, message: '请输入电话', trigger: 'blur' }
                ],
                address: [
                    { required: true, message: '请输入地址', trigger: 'blur' }
                ]
            }
        }
    },
    mounted() {
        let query = this.$route.query
        if (query.id) {
          const {name, tel, address } = query.row
          Object.assign(this.form, {
            name,
            tel,
            address
          })
        }
    },
    methods: {
        /**
         * [handleCommit description] 提交
         * @param  {[type]} formName [description]
         * @return {[type]}          [description]
         */
        handleCommit: function(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;

                    const { name, tel, address } = this.form
                    let param = {
                        name,
                        tel,
                        address
                    }

                    if(this.id) {
                        param.id = this.id;
                    }

                    serviceShopSaveOrUpdate(param).then(res =>{
                        this.btnLoading = false;

                        let { code, data, msg } = res;

                        if(code == 0) {
                            this.$message.success('保存成功');
                            this.handleback()
                        } else {
                            this.$message.error(msg);
                        }
                    }).catch(error => {
                        this.btnLoading = false;
                        this.$message.error('服务器异常');
                    });
                    
                } else {
                    return false;
                }
            });
        },
        /**
         * [handleback description] 取消-返回列表
         * @return {[type]}          [description]
         */
        handleback: function() {
            this.$router.push('/service/store/list');
        },
    }
}
</script>

<style lang="scss" scoped>
    .input-delete-wrap{
        margin: 2px 10px 2px 0;
        & + .input-delete-wrap{
            margin-left: 0 !important;
        }

        &:last-of-type{
            margin-right: 0;
        }
    }
</style>

